import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { EmploymentHistoryControl } from "./EmploymentHistoryControl";
import { EmploymentHistorySummaryControl } from "./EmploymentHistorySummaryControl";

/* eslint-disable react-hooks/rules-of-hooks */
function _EmploymentHistoryControl(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <EmploymentHistorySummaryControl {...props} />;
  }

  return <EmploymentHistoryControl {...props} />;
}
/* eslint-enable react-hooks/rules-of-hooks */

export const EmploymentHistoryControlRenderer = withJsonFormsArrayControlProps(
  _EmploymentHistoryControl
);
